import { render } from "./BlockView.vue?vue&type=template&id=01d7495e&ts=true"
import script from "./BlockView.vue?vue&type=script&lang=ts"
export * from "./BlockView.vue?vue&type=script&lang=ts"

import "./BlockView.vue?vue&type=style&index=0&id=01d7495e&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__